var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateInvoice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0827 9.41601V5.86602C17.0827 2.50769 16.2993 1.66602 13.1493 1.66602H6.84935C3.69935 1.66602 2.91602 2.50769 2.91602 5.86602V15.2493C2.91602 17.466 4.13269 17.991 5.60769 16.4077L5.61601 16.3993C6.29934 15.6743 7.34101 15.7327 7.93267 16.5243L8.77435 17.6493",
    stroke: "#1E2328",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 5.83398H13.3327",
    stroke: "#1E2328",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.16602H12.5",
    stroke: "#1E2328",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6484 17.2917V11.875",
    stroke: "url(#paint0_linear_4986_12523)",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2917 14.584H11.875",
    stroke: "url(#paint1_linear_4986_12523)",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4986_12523",
    x1: 14.0703,
    y1: 10.4167,
    x2: 15.2519,
    y2: 10.5145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586388,
    stopColor: "#FC8E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4986_12523",
    x1: 12.0833,
    y1: 13.584,
    x2: 17.1514,
    y2: 17.5595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586388,
    stopColor: "#FC8E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F7C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateInvoice);
export default __webpack_public_path__ + "static/media/createInvoice.5e297b06351ab1ea0520c64a85e24d78.svg";
export { ForwardRef as ReactComponent };